import { useContext } from 'react';
import { ConfigContext } from '../../providers/ConfigProvider/ConfigProvider';

export const useConfig = () => {
  const context = useContext(ConfigContext);
  const { config } = context;

  return config;
};
